import dayjs from "dayjs";
import { SiteResponse } from "src/Data/Responses/SiteResponse";
import { SiteWindowResponse } from "src/Data/Responses/SiteWindowResponse";

export interface KillswitchEngageProps {
    SiteProperties: SiteResponse,
    SiteTimeWindows: Array<SiteWindowResponse> | undefined
}

export function KillswitchEngage(props: KillswitchEngageProps) {
    const _debug = false;
    if (_debug) console.log("KillswitchEngage");
    if (_debug) console.log(props);
    let theseSiteTimeWindows: Array<SiteWindowResponse> = [];

    if (props.SiteTimeWindows !== undefined) {
        const PIT = dayjs();

        props.SiteTimeWindows.filter(th => th.IsKnownDowntime).forEach(STW => {
            const _from = dayjs(STW.WindowStart);
            const _to = dayjs(STW.WindowEnd);

            if (PIT.isAfter(_from) && PIT.isBefore(_to)) {
                theseSiteTimeWindows.push(STW);
            }
        });
    }

    if (props.SiteProperties.Killswitch) {
        if (theseSiteTimeWindows.length > 0) {
            return <div>
                <h1 className="WarningTitle">Accommodation applications system gateway: temporarily unavailable for scheduled maintenance</h1>
                <div className="GatewayErrorBlock">
                    <p>The accommodation applications system is temporarily unavailable due to essential
                        maintenance work.</p>
                    <p>It will be unavailable between <b>{
                        dayjs.utc(theseSiteTimeWindows[0].WindowStart).format('HH:mm on DD-MM-YYYY')
                    }</b>, and <b>{
                        dayjs.utc(theseSiteTimeWindows[0].WindowEnd).format('HH:mm on DD-MM-YYYY')
                    }</b> (Times local to the UK). Please try again after these times.</p>
                    <p>Any inconvenience is regretted.</p>
                    <p>Enquiries regarding this system should be directed to the Student Services Hub (e-mail:
                        <a href="mailto:askthehub@essex.ac.uk">askthehub@essex.ac.uk</a>).</p>
                </div>
            </div>
        } else {
            return <div>
                <h1 className="WarningTitle">Accommodation applications system gateway: temporarily unavailable</h1>
                <div className="GatewayErrorBlock">
                    <p>The accommodation applications system is temporarily unavailable.</p>
                    <p>Please try again later.</p>
                    <p>Any inconvenience is regretted.</p>
                    <p>Enquiries regarding this system should be directed to the Student Services Hub (e-mail:
                        <a href="mailto:askthehub@essex.ac.uk">askthehub@essex.ac.uk</a>).</p>
                </div>
            </div>
        }
    } else {
        return <></>;
    }
}
